var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4.375H5.25C4.76675 4.375 4.375 4.76675 4.375 5.25V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V5.25C23.625 4.76675 23.2332 4.375 22.75 4.375Z",
    stroke: "#2A272E",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 17.4999L18.9937 12.8686C18.8296 12.7045 18.6071 12.6123 18.375 12.6123C18.1429 12.6123 17.9204 12.7045 17.7563 12.8686L12.8687 17.7562C12.7046 17.9202 12.4821 18.0124 12.25 18.0124C12.0179 18.0124 11.7954 17.9202 11.6313 17.7562L9.36872 15.4936C9.20462 15.3295 8.98206 15.2373 8.75 15.2373C8.51793 15.2373 8.29537 15.3295 8.13128 15.4936L4.375 19.2499",
    stroke: "#2A272E",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 11.375C11.6624 11.375 12.25 10.7874 12.25 10.0625C12.25 9.33763 11.6624 8.75 10.9375 8.75C10.2126 8.75 9.625 9.33763 9.625 10.0625C9.625 10.7874 10.2126 11.375 10.9375 11.375Z",
    fill: "#2A272E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSquare);
export default __webpack_public_path__ + "static/media/ImageSquare.e5e56708243fc95b40acf5c94d4ec52e.svg";
export { ForwardRef as ReactComponent };